module.exports = __webpack_public_path__ + "img/sciencepage7.af92b447.png";